
<template>
     <a-select v-if="isForm" show-search :value="value" placeholder="输入渠道名称" allow-clear style="width: 300px"
            :default-active-first-option="false" :filter-option="true" :not-found-content="null" :disabled="isDisabled"
             @change="handleChange">
            <a-select-option v-for="d in data" :key="d.value">
                {{ d.text }}
            </a-select-option>
        </a-select>
    <a-card v-else size="small" style="border-top:none;border-bottom:none;">
        <label style="color:#262626;" for="">当前渠道：</label>
        <a-select show-search :value="value" placeholder="输入渠道名称" allow-clear style="width: 300px"
            :default-active-first-option="false" :filter-option="true" :not-found-content="null" :disabled="isDisabled"
             @change="handleChange">
            <a-select-option v-for="d in data" :key="d.value">
                {{ d.text }}
            </a-select-option>
        </a-select>
    </a-card>

</template>
<script>
let mcmsmanagerstoreKey = 'commonChannelCode';
export default {
    data() {
        return {
            data: [],
            value:undefined,
            searchTimmer:null
        }
    },

    props:{
        isForm:Boolean,
        isDisabled:Boolean,
        isEmpty:Boolean,
    },

    methods: {
        setInputVal(val){
            this.value = val
        },
        handleChange(value) {
            this.value = value;
            let targetData = this.data.filter((item) => { return item.value == value });
            if(targetData.length > 0){
                this.$emit('onChannelCodeChange',targetData[0]);
                localStorage.setItem(mcmsmanagerstoreKey,value);
            }
        },
        doSearch(value) {
            let that = this;
            let c_params = {
                urlparams: false,
                channelname: value,
            }

            that.$store.dispatch({
                type: "mcmsmanager/querychannels",
                params: c_params,
                showMsg: false
            }).then((res) => {
                if (res.data.success == 1) {
                    that.data = [];
                    let result = res.data.data;
                    if(!result){
                        that.message.error("未查询到渠道");
                        return;
                    }
                    result.forEach(r => {
                        that.data.push({
                            value: r.channelcode,
                            text: r.channelname,
                            platformtype:r.platformtype
                        });
                    });
                    that.checkDefault();
                }
            }).catch(() => {

            });
        },
        checkDefault(){
            //
            if(this.isEmpty){
                this.handleChange('');
                return
            }
            let storeData =  localStorage.getItem(mcmsmanagerstoreKey);
            if(storeData){
                let tempItem = this.data.filter( item => { return item.value == storeData });
                if(tempItem.length > 0){
                    this.handleChange(storeData);
                }
                else{
                    this.handleChange(this.data[0].value);
                    localStorage.setItem(mcmsmanagerstoreKey,this.value);
                }
            }
            else{
                this.handleChange(this.data[0].value);
                localStorage.setItem(mcmsmanagerstoreKey,this.value);
                
            }
        }
    },
    mounted(){
        this.doSearch('')
    }
   
};
</script>

<style scoped>

</style>
